export const model = {
    id: null,
    name: "",
    code: "",
    specialty: null,
    parent_id: null,
    created_at: '',
    updated_at: ''
};